export { default } from "./PlasmidInteractiveMap";
